<div class="summary-field" *ngIf="showSummaryField">
  <p><span class="label">{{ label }}</span><span *ngIf="!valueIsBoolean">: {{ value }}</span></p>
</div>
